// SPDX-License-Identifier: Apache-2.0
import IGirafeContext from '../context/icontext';
import type { IBrainSerializer } from '../state/brain/serialize';
import DrawingFeature, { type SerializedFeature } from './drawingFeature';
import DrawingState from './drawingState';

export default class DrawingSerializer implements IBrainSerializer<DrawingState> {
  private readonly context: IGirafeContext;

  public constructor(context: IGirafeContext) {
    this.context = context;
  }

  private get state() {
    return this.context.stateManager.state;
  }

  public brainSerialize(drawingState: DrawingState): string {
    const serializedDrawings: SerializedFeature[] = [];
    for (const feature of drawingState.features) {
      serializedDrawings.push(feature.serialize());
    }
    return JSON.stringify(serializedDrawings);
  }

  public brainDeserialize(str: string, stateLocation: string) {
    const serializedFeatures = JSON.parse(str);
    if (serializedFeatures) {
      let drawingState: DrawingState = new DrawingState();
      if (this.state.extendedState[stateLocation]) {
        // First, delete existing drawing features in the state before adding new ones.
        //  This will trigger removal of the ol features in the map.
        drawingState = this.state.extendedState[stateLocation] as DrawingState;
        drawingState.features.splice(0, drawingState.features.length);
      } else {
        this.state.extendedState[stateLocation] = drawingState;
      }

      serializedFeatures.forEach((f: SerializedFeature) => DrawingFeature.deserialize(f, this.context, drawingState));
    } else {
      throw new Error(`Cannot deserialize the drawing state for ${stateLocation}`);
    }
  }
}
